<template>
	<div>
		<div class="chat-item" :class="{ active: active, 'is-top': isTop }" @contextmenu.prevent="showRightMenu($event)">
			<div class="chat-left">
				<head-image :url="chat.headImage" :name="chat.showName" :size="45" :online="online"
					:variant="chat.type == 'GROUP' ? 'group' : 'user'"
					:id="chat.type == 'PRIVATE' ? chat.targetId : 0" :isShowUserInfo="false"></head-image>
				<div v-if="showUnreadBadge" class="unread-text">{{ unreadCountText }}</div>
			</div>
			<div class="chat-right">
				<div class="chat-name">
					<div class="chat-name-main">
						<div class="chat-name-text" :title="chat.showName">{{ chat.showName }}</div>
					</div>
					<div class="chat-name-meta">
						<div class="chat-tag">
							<el-tag v-if="isTop" size="mini" effect="plain" class="chat-pill chat-pill--top" type="warning">顶</el-tag>
							<el-tag v-if="chat.type == 'SYSTEM'" size="mini" effect="plain" class="chat-pill chat-pill--system" type="danger">官方</el-tag>
						</div>
						<div class="chat-time-text">{{ showTime }}</div>
					</div>
				</div>
				<div class="chat-content">
					<div v-if="atText" class="chat-at-text chat-status-text">{{ atText }}</div>
					<div v-if="sendNameText" class="chat-send-name" :class="{ 'is-active': active }">{{ sendNameText }}</div>
					<div v-if="chat.draftText" class="chat-draft-text chat-status-text">[草稿]</div>
					<div class="chat-content-text" :class="{ 'is-active': active }"
						v-html="$emo.transform($str.html2Escape(previewText), 'emoji-small')"></div>
					<div class="icon iconfont icon-dnd" v-if="isDnd"></div>
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {}
	},
	props: {
		chat: {
			type: Object
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		showRightMenu(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.msgInfo);
		}
	},
	computed: {
		isDnd() {
			return this.chatStore.isDnd(this.chat);
		},
		isTop() {
			return this.chatStore.isTop(this.chat);
		},
		showUnreadBadge() {
			return !this.isDnd && this.chat.unreadCount > 0;
		},
		unreadCountText() {
			if (this.chat.unreadCount > 99) {
				return '99+';
			}
			return this.chat.unreadCount;
		},
		sendNameText() {
			if (!this.chat.sendNickName) {
				return '';
			}
			if (this.chat.summaryOnly) {
				return this.$msgType.isNormal(this.chat.lastMessageType) ? `${this.chat.sendNickName}:` : '';
			}
			let size = this.chat.messages.length;
			if (size == 0) {
				return '';
			}
			// 只有群聊的普通消息需要显示名称
			let lastMsg = this.chat.messages[size - 1];
			if (!this.$msgType.isNormal(lastMsg.type)) {
				return '';
			}
			return `${this.chat.sendNickName}:`;
		},
		previewText() {
			if (this.chat.draftText) {
				return this.chat.draftText;
			}
			return this.chat.lastContent || '';
		},
		showTime() {
			return this.$date.toTimeText(this.chat.lastSendTime, true)
		},
		atText() {
			if (this.chat.atMe) {
				return "[有人@我]"
			} else if (this.chat.atAll) {
				return "[@全体成员]"
			}
			return "";
		},
		menuItems() {
			let items = [];

			if (this.chat.type == 'PRIVATE' || this.chat.type == 'GROUP') {
				// 置顶功能（检查配置）
				const topLimit = this.$permission.getSessionTopLimit();
				if (topLimit !== 0) {
					if (!this.isTop) {
						items.push({
							key: 'TOP',
							name: '置顶',
							icon: 'el-icon-top'
						})
					} else {
						items.push({
							key: 'TOP',
							name: '取消置顶',
							icon: 'el-icon-top'
						})
					}
				}
				items.push({
					key: 'INFO',
					name: '查看资料',
					icon: 'el-icon-user'
				});
				if (this.isDnd) {
					items.push({
						key: 'DND',
						name: '新消息提醒',
						icon: 'el-icon-bell'
					})
				} else {
					items.push({
						key: 'DND',
						name: '消息免打扰',
						icon: 'el-icon-bell'
					})
				}
			}
			items.push({
				key: 'DELETE',
				name: '删除聊天',
				icon: 'el-icon-delete',
				danger: true
			})
			return items;
		},
		online() {
			if (this.chat.type == 'PRIVATE') {
				let friend = this.friendStore.findFriend(this.chat.targetId);
				return friend && friend.online;
			}
			return false;
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-item {
	height: 68px;
	box-sizing: border-box;
	display: flex;
	position: relative;
	margin: 0;
	padding: 8px 12px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;
	border-radius: 0;
	transition: background-color 0.15s ease, box-shadow 0.15s ease;

	// 左侧选中指示器
	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%) scaleY(0);
		width: 3px;
		height: 24px;
		border-radius: 0 2px 2px 0;
		background: var(--im-session-indicator);
		transition: transform 0.2s ease;
	}

	&:hover {
		background-color: rgba(var(--im-primary-rgb), 0.025);
	}

	&.active {
		background-color: rgba(var(--im-primary-rgb), 0.095);
		box-shadow: inset 0 0 0 1px rgba(var(--im-primary-rgb), 0.08);

		&::before { transform: translateY(-50%) scaleY(1); }

		.chat-name-text { color: var(--im-session-text); font-weight: 600; }
	}

	&.is-top {
		background: rgba(var(--im-orange-rgb), 0.024);
		box-shadow: inset 0 0 0 1px rgba(var(--im-orange-rgb), 0.06);
	}

	&.is-top.active {
		background: rgba(var(--im-primary-rgb), 0.095);
		box-shadow: inset 0 0 0 1px rgba(var(--im-primary-rgb), 0.08);
	}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		width: 45px;
		height: 45px;

		.unread-text {
			position: absolute;
			background-color: var(--im-color-danger);
			right: -3px;
			top: -3px;
			color: white;
			border-radius: 999px;
			padding: 0 5px;
			min-width: 18px;
			height: 18px;
			font-size: 10px;
			font-weight: 600;
			line-height: 18px;
			text-align: center;
			white-space: nowrap;
			border: 2px solid var(--im-session-bg);
			box-shadow: 0 1px 2px rgba(var(--im-black-rgb), 0.08);
		}
	}

	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: inline-flex;
			align-items: flex-start;
			align-self: flex-start;
			max-width: 100%;
			line-height: 19px;
			min-height: 20px;
			gap: 4px;

			.chat-name-main {
				flex: 0 1 auto;
				min-width: 0;
				max-width: 100%;
				display: flex;
				align-items: center;
				gap: 3px;
			}

			.chat-name-text {
				flex: 0 1 auto;
				min-width: 0;
				max-width: 100%;
				font-size: 14px;
				font-weight: 550;
				line-height: 19px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				color: var(--im-session-text);
			}

			.chat-name-meta {
				display: flex;
				align-items: center;
				gap: 4px;
				flex: 0 1 auto;
				min-width: 0;
				padding-top: 1px;
				justify-content: flex-end;
			}

			.chat-tag {
				display: flex;
				align-items: center;
				gap: 4px;
				flex-shrink: 0;

				:deep(.el-tag) {
					height: 15px;
					line-height: 13px;
					padding: 0 2px;
					border-radius: 999px;
					font-size: 9px;
					border-color: var(--im-control-border);
				}
			}

			.chat-time-text {
				font-size: 10px;
				line-height: 16px;
				text-align: right;
				color: var(--im-session-text-muted);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 2px;
				padding-top: 1px;
				min-width: 40px;
				font-variant-numeric: tabular-nums;
				flex-shrink: 0;
			}
		}

		.chat-content {
			display: flex;
			align-items: center;
			min-width: 0;
			gap: 3px;
			line-height: 17px;
			height: 17px;
			margin-top: 3px;

			.chat-status-text {
				flex-shrink: 0;
				font-size: 11px;
				font-weight: 500;
				line-height: 17px;
				letter-spacing: -0.01em;
				white-space: nowrap;
			}

			.chat-at-text {
				color: var(--im-color-danger);
			}

			.chat-send-name {
				flex-shrink: 0;
				max-width: 72px;
				font-size: 11px;
				line-height: 17px;
				color: var(--im-session-preview-text);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				&.is-active {
					color: var(--im-session-preview-text-active);
				}
			}

			.chat-draft-text {
				flex-shrink: 0;
				color: var(--im-color-danger);
			}

			.chat-content-text {
				flex: 1;
				min-width: 0;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 11px;
				line-height: 17px;
				color: var(--im-session-preview-text);

				&.is-active {
					color: var(--im-session-preview-text-active);
				}
			}

			.icon {
				flex-shrink: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 11px;
				color: var(--im-session-text-muted);
				margin-left: 4px;
				background: var(--im-control-soft-bg);
				border: none;
				border-radius: 50%;
				width: 16px;
				height: 16px;
			}
		}
	}
}
</style>
